// admin/src/menu-items/dashboard.jsx
// assets
import { DashboardOutlined, BarChartOutlined, LineChartOutlined, PieChartOutlined } from '@ant-design/icons';

// icons
const icons = {
  DashboardOutlined,
  BarChartOutlined,
  LineChartOutlined,
  PieChartOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'group-dashboard',
  title: 'Tableau de Bord',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Vue d\'ensemble',
      type: 'item',
      url: '/dashboard/default',
      icon: icons.DashboardOutlined,
      breadcrumbs: false
    },
  ]
};

export default dashboard;
